/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IResetPasswordWithTokenScope extends ng.IScope {
        vm: PasswordResetWithToken
    };

    interface IPasswordResetRouteParams extends angular.route.IRouteParamsService {
        email: string;
        token: string;
    }
    interface IResetPasswordWithToken {


    }

    class PasswordResetWithToken implements IResetPasswordWithToken {
        static controllerId: string = "passwordResetWithToken";
        static $inject: Array<string> = ["$scope", "common", "$location", "$routeParams", "Restangular", "config"];

        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        newPassword: string;
        confirmPassword: string;
        email: string;
        token: string;
        baseUrl: string;
        authHost: string;
        success: boolean = false;
        saving: boolean = false;

        constructor(private $scope: IResetPasswordWithTokenScope,
            private common: ICommonFactory,
            private $location: ng.ILocationService,
            private $routeParams: IPasswordResetRouteParams,
            private Restangular: Restangular.IService,
            private config: IConfig
        ) {
            this.log = common.logger.getLogFn(PasswordResetWithToken.controllerId);
            this.logError = common.logger.getLogFn(PasswordResetWithToken.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(PasswordResetWithToken.controllerId, "success");

            this.email = angular.copy(this.$routeParams.email);
            this.token = angular.copy(this.$routeParams.token);
            this.baseUrl = encodeURIComponent(config.umbracoUrl);
            console.log(encodeURIComponent(config.umbracoUrl));
            console.log(this.baseUrl);
            this.authHost = config.authHost;

            this.$location.search("email", null);
            this.$location.search("token", null);
        }

        activate() {
            this.common.activateController([], PasswordResetWithToken.controllerId).then(() => {
                this.log("Activated ResetPasswordWithToken View");
            });
        }

        resetPassword = () => {
            var data = {
                email: this.email,
                token: this.token,
                newPassword: this.newPassword
            }
            this.saving = true;

            this.Restangular.all("account").all("resetPasswordWithToken").post(data).then((result) => {
                this.logSuccess("Password reset successfully.", null, false);
                this.success = true;
                this.saving = false;
            }, (reason) => {
                this.logError("An error occurred resetting your password", reason, true);
                this.saving = false;
            });
        };
    }

    angular.module("app").controller(PasswordResetWithToken.controllerId, PasswordResetWithToken);
}